import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { createPortal } from "react-dom";

import { getFilterOptions } from "../../helpers/getTranslatedFilterOptions";
import { TextInputType } from "components/prime-data-table/interfaces/edit-interfaces";
import { FilteringType } from "components/prime-data-table/interfaces";

interface IFilterTypePopupProps {
    filterType: FilteringType;
    handleFilterTypeChange: Function;
    t: Function;
    type: TextInputType;
    tableRef?: any;
    inputRef?: any;
}

export const FilterTypePopup = ({ filterType, handleFilterTypeChange, t, type, tableRef, inputRef }: IFilterTypePopupProps) => {
    const popUpRef = useRef<HTMLDivElement>(null);
    const [filterTypeValue, setFilterTypeValue] = useState<FilteringType | undefined>(undefined);
    const [popUpPosition, setPopUpPosition] = useState<any>({ top: 0, left: 0, width: 0 });

    const [popUpOpen, setPopUpOpen] = useState<boolean>(false);

    const translatedOptions = getFilterOptions(type);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popUpRef.current && !popUpRef.current.contains(event.target) && !event.target.className.includes("p-dropdown-item"))
                closePopUp();
        };

        if (popUpOpen) {
            setFilterTypeValue(filterType);
            document.addEventListener("mousedown", handleClickOutside);
            checkPopUpPosition();
        }

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [popUpOpen]);

    const checkPopUpPosition = () => {
        if (tableRef.current && popUpRef.current) {
            const tabelWidth = tableRef.current?.offsetWidth;
            const popUpInputWidth = inputRef.current?.offsetWidth;

            const popUpPositionY = inputRef.current?.offsetTop * 0.5 + inputRef.current?.offsetHeight + tableRef.current?.offsetTop;
            const popUpPositionX = inputRef.current?.offsetLeft + tableRef.current?.offsetLeft;
            const popUpWidth = inputRef.current?.offsetWidth > 175 ? inputRef.current?.offsetWidth : 175;

            let _popUpPosition = { top: popUpPositionY, left: popUpPositionX, width: popUpWidth };

            if (tabelWidth - (inputRef.current?.offsetLeft + popUpWidth + 6) <= 0) {
                _popUpPosition = { ..._popUpPosition, left: popUpPositionX + (popUpInputWidth - popUpWidth) };
            }

            setPopUpPosition(_popUpPosition);
        }
        return false;
    };

    const closePopUp = () => setPopUpOpen(false);

    const handleSaveFilterType = () => {
        handleFilterTypeChange(filterTypeValue);
        closePopUp();
    };

    return (
        <>
            <span onClick={() => setPopUpOpen(true)} className={"pi pi-cog state-input-filter-settings-button"} />

            {popUpOpen &&
                createPortal(
                    <div className="popup" style={popUpPosition} ref={popUpRef}>
                        <Dropdown
                            className="custom-search-table-input prime-table-filter-input-font"
                            value={filterTypeValue}
                            options={translatedOptions}
                            onChange={(e) => setFilterTypeValue(e.target.value)}
                            optionLabel="label"
                            optionValue="value"
                            placeholder={`${t("Filter Type")}`}
                            name="filterType"
                        />
                        <span
                            className="popup-btn btn btn-outline-brand ml-5 mt-5 mr-10 mb-5"
                            onClick={handleSaveFilterType}
                            title={t("Save")}
                        >
                            {t("Save")}
                        </span>
                    </div>,
                    tableRef.current
                )}
        </>
    );
};
